export const USER_INFO = {
  name: "Rishab Salgotra",
  title: "Principal Lead, Platforms & NextGen Products @ FAB",
  tagline: "Driving Digital Transformation | Blockchain, AI, Cloud",
  organization: "First Abu Dhabi Bank (FAB)",
  brief: "With over two decades of experience, I currently serve as Principal Lead for Platforms & NextGen Products at First Abu Dhabi Bank, where I focus on designing, implementing, and delivering next-generation enterprise platforms. My work emphasizes Blockchain innovation, API-led Connected Banking, Cloud transformation, and AI-enabled modernization — collaborating closely with the Wholesale Banking CIO and senior leaders to drive large-scale digital transformation initiatives.",
  location: "Dubai, United Arab Emirates",
  email: "r.salgotra@gmail.com",
  linkedin: "https://www.linkedin.com/in/rishabsalgotra",
  topSkills: ["Blockchain", "Architectural Design", "Artificial Intelligence (AI)"],
  education: {
    degree: "Bachelor of Technology (B.Tech)",
    major: "Electrical, Electronics and Communications Engineering",
    school: "Baba Banda Singh Bahadur Engineering College",
    period: "1998 - 2002"
  },
  portraitUrl: "https://customer-assets.emergentagent.com/job_github-clone-51/artifacts/sl2nuthz_rishab-modified.JPG",
  certifications: [
    { name: "Digital Disruption: Digital Transformation Strategies", issuer: "Cambridge Judge Business School", image: "/certificates/Digital Disruption.png" },
    { name: "The Open Group Certified: TOGAF® 9 Certified", issuer: "The Open Group", image: "/certificates/opengroup.png" },
    { name: "AWS Certified Solutions Architect – Professional", issuer: "Amazon Web Services", image: "/certificates/aws.png" },
    { name: "Associate Cloud Engineer Certification", issuer: "Google Cloud", image: "/certificates/gcp.png" },
    { name: "ITIL Foundation Certificate in IT Service Management", issuer: "PeopleCert", image: "/certificates/ITIL.png" },
    { name: "CompTIA A+ Certified Professional", issuer: "CompTIA", image: "/certificates/CompTIA.png" },
    { name: "Certified SAFe® 6 Agilist", issuer: "Scaled Agile, Inc.", image: "/certificates/safe.png" },
    { name: "Microsoft Certified: Azure Fundamentals", issuer: "Microsoft", image: "/certificates/azure.png" },
    { name: "Oracle Cloud Infrastructure 2021 Architect Associate", issuer: "Oracle", image: "/certificates/oracle.png" },
  ],
  awards: [
    { title: "Guiding Star", org: "Leadership Recognition" },
    { title: "Enterprise Engineer", org: "Specialist Delivery Excellence" }
  ]
};

export const PROJECTS = [
  {
    id: "blockchain-assets",
    title: "Digital Assets & Tokenization Platform",
    subtitle: "Real-Time Corporate Settlement",
    category: "Blockchain Innovation",
    techStack: ["Smart Contracts", "Tokenization", "Solidity", "Java"],
    description: "Leading blockchain initiatives at FAB enabling digital assets, tokenization, smart contracts, and real-time settlement for corporate banking use cases. Built to bring institutional-grade trust and transparency to enterprise transactions.",
    image: "https://lh3.googleusercontent.com/aida-public/AB6AXuDaTyByiV7T2Hi1SvUuS7HLJRuCI5cuPL6ziZSfCumWB45HqJYRUywqc0_jp-wEF4V8-SpkmsrRMHsXgPsSYNIjA0d11EGyqgP-uK2JuazsHrQbGE0BiysHsR1_BXLSwuGFLX4NgvJKZaKBPB85elYmQJ-kvY87wyv9n2OhpA_kKq59HsMVJN1YGioyVacIwTTEPcMF7dokUY7-vZ5kblBAAoECVZa0By857dzX2ieI4eG2_kt_ZncHy5qUzi6Hs3kihmFrjbTcJ5Q",
    metrics: [
      { label: "Settlement", value: "Real-Time" },
      { label: "Use Case", value: "Corporate" },
      { label: "Pattern", value: "On-chain" }
    ]
  },
  {
    id: "api-h2h",
    title: "API & Host-to-Host Banking",
    subtitle: "Embedded & Open Ecosystem",
    category: "Connected Banking",
    techStack: ["REST APIs", "Spring Boot", "Kubernetes", "Azure"],
    description: "Drives API & Host-to-Host (H2H) platform strategy and delivery — enabling embedded banking, corporate integration, and open ecosystem connectivity. Modernised channels for institutional clients across the FAB Global Corporate Network.",
    image: "https://lh3.googleusercontent.com/aida-public/AB6AXuCn_kXXiIM_pFqXR8-5OPM_J8H2G_ULCJLgzi_NxSvq6B4UCz2qtDUP0P5QSQ6BGwd0GGTnwUAfaVUeFbauJ6sLTnosbo3ahLsM-QNesATA5CCOG5xZf7B6GX_y6uf5epDiQnEtTivCln6m2TbDN-UAZaeHx7xFpXlKcGK_fzfbyDtuA2v9NiKh8PA7Y3N--KPUZYhZC48oeDvPDOD7IsdqjledN1-QI_vf3U5jvocWHTVmghKiBzs7ZV7L6_CexNm7_rwguEuUXak",
    metrics: [
      { label: "Channels", value: "API + H2H" },
      { label: "Network", value: "Open Finance" },
      { label: "Clients", value: "Institutional" }
    ]
  },
  {
    id: "cloud-strategy",
    title: "Multi-Cloud Banking Platform",
    subtitle: "AWS + GCP Scalable Architecture",
    category: "Cloud Transformation",
    techStack: ["AWS", "GCP", "Terraform", "Kubernetes"],
    description: "Leads cloud strategy and adoption across retail and corporate applications, leveraging AWS and GCP for scalable, resilient, and high-performance solutions. Co-designed cloud-native patterns adopted globally during HSBC modernisation programs.",
    image: "https://lh3.googleusercontent.com/aida-public/AB6AXuBDqBS_zni2o39e8094RIXJ-jdcOAdXQKJlLIBzKYd7BcyxXfCCEQVrIzjW0nCsOCk8rY5aaGUa1kVb3UwS3KYtW_DtjgkAQv7o0sQomWUUoz9zYKSS6swpni6_ktAZf0iXuVeLRZKHiG_EPYp3GNfPd-lN8eVl2mJXkPfaAh_AzP_RELzb6PbEs6wLHJxp5wanPE_jNHk4nNtLnp89dLbfnfw2QdNGk5EvODeUqf8JiLkGhy4Aj_aCeoXpgCJWZRGt4jKkM_PnQPw",
    metrics: [
      { label: "Providers", value: "AWS + GCP" },
      { label: "Scale", value: "Enterprise" },
      { label: "Adoption", value: "Cloud-Native" }
    ]
  },
  {
    id: "treasury-escrow",
    title: "Treasury & Escrow Modernization",
    subtitle: "Automation, Liquidity & Governance",
    category: "Enterprise Platforms",
    techStack: ["Java/Spring", "Oracle", "Kafka", "AI/ML"],
    description: "Oversees Treasury and Escrow platform transformation — enhancing automation, liquidity visibility, governance, and secure transaction processing. Embeds AI/ML intelligence to improve prediction, automation, and operational efficiency.",
    image: "https://lh3.googleusercontent.com/aida-public/AB6AXuAyYC7XoVyeZC2q4JKu31Bh8yZE_NK9T3urIRCapn4bPHuGAhJ9MYCV7TCr-6DRoYYb78Kqc44uWuzkCRvMjUGqItIuVWFFFtGAWuR3U7Vg8G0xQQ3iNcyvYRfhwDK5IQqpOfqN44IL3YH2eLRNiIZfr5q0TRFVjpPAgkPA-Ro5Io8pMVDrNoaaF-nEdIfnA1vbwasE6mXCRpSLzWQFM1lCq_lfCC9GXkyV2Zon9bAnxanfu6jLvaQbMaN2mT-mdp9j-RGY6baW6oQ",
    metrics: [
      { label: "Domain", value: "Treasury" },
      { label: "Intelligence", value: "AI/ML" },
      { label: "Governance", value: "Enhanced" }
    ]
  }
];

export const CAREER_PATH = [
  {
    period: "October 2025 - Present",
    role: "Principal Lead, Platforms & NextGen Products",
    company: "First Abu Dhabi Bank (FAB)",
    location: "Dubai, United Arab Emirates",
    details: [
      "Lead the delivery, design, and implementation of FAB's next-generation enterprise platforms with strong focus on Blockchain, API-led Connected Banking, Cloud, and AI modernization.",
      "Drive blockchain initiatives enabling digital assets, tokenization, smart contracts, and real-time settlement for corporate banking use cases.",
      "Drive API & Host-to-Host (H2H) platform strategy — enabling embedded banking, corporate integration, and open ecosystem connectivity.",
      "Provide architecture leadership, defining platform blueprints, integration patterns, and modernization frameworks for enterprise systems.",
      "Lead cloud strategy and adoption across retail and corporate applications, leveraging AWS and GCP for scalable, resilient, and high-performance solutions.",
      "Oversee Treasury and Escrow platform transformation, enhancing automation, liquidity visibility, governance, and secure transaction processing.",
      "Embed AI/ML intelligence across platforms to improve prediction, automation, and operational efficiency.",
      "Work directly with the Wholesale Banking CIO, product leadership, and business stakeholders to shape strategy, drive governance, and ensure enterprise-wide alignment."
    ],
    featured: true
  },
  {
    period: "March 2022 - August 2025",
    role: "Service Owner - CIB GCN",
    company: "First Abu Dhabi Bank (FAB)",
    location: "Dubai, United Arab Emirates",
    details: [
      "Deep domain expertise in Corporate Banking — Payments, Cash Management, Trade Finance, Loans, and Transaction Banking.",
      "Lead technology delivery for API Banking, Mobile & Web Channels, and Open Finance / Open API ecosystems.",
      "Manage mission-critical applications on AWS & Azure using Terraform, Java/Spring Boot, React/Angular, PCF, Kubernetes, Docker, Jenkins, and REST APIs.",
      "Own the end-to-end technology service roadmap, ensuring alignment with business priorities and digital strategy.",
      "Define and maintain Service Strategy & Catalogue including demand planning, release governance, and cross-team coordination.",
      "Champion Agile, DevOps, and AIOps practices to enhance delivery speed, reliability, monitoring, and automation.",
      "Ensure compliance with financial, risk, and regulatory requirements across services."
    ]
  },
  {
    period: "March 2020 - February 2022",
    role: "Delivery Head - Head of Browser Foundation Engineering",
    company: "HSBC",
    location: "Pune, Maharashtra, India",
    details: [
      "Led end-to-end delivery of a strategic global customer-facing banking platform, managing large distributed teams across multiple geographies.",
      "Provided strong technology and stakeholder leadership, aligning business, product, risk, compliance, and global teams to a unified delivery and transformation roadmap.",
      "Deep expertise across Retail Banking (digital channels, payments, onboarding, customer journeys) and Investment Banking (trading workflows, settlements, regulatory and risk controls).",
      "Oversaw a diverse enterprise stack: IBM WebSphere, Java, Spring, JavaScript/Dojo, MQ, Oracle, SOAP services, Jenkins, AppDynamics, and Akamai CDN.",
      "Led design and implementation of major modules like Dashboard and Move Money, ensuring scalable, secure, and customer-centric solutions."
    ],
    featured: true
  },
  {
    period: "April 2016 - March 2020",
    role: "Senior Lead Consultant Specialist",
    company: "HSBC",
    location: "Pune Area, India",
    details: [
      "Led global delivery teams to execute multiple digital transformation projects, modernising HSBC's Internet Banking platform across international markets.",
      "Drove end-to-end delivery of complex customer-facing initiatives, improving digital experience, performance, and platform stability at global scale.",
      "Built deep expertise in cloud computing and led the cloud adoption strategy for retail banking applications.",
      "Worked closely with AWS and GCP teams to design and deliver cloud-based, scalable, and secure application architectures.",
      "Guided global engineering teams in adopting cloud-native patterns, DevOps practices, and modern application design."
    ]
  },
  {
    period: "April 2010 - April 2016",
    role: "Senior Consultant Specialist",
    company: "HSBC",
    location: "Pune Area, India",
    details: [
      "Led hands-on development for the Account Opening System using IBM WebSphere Portal, J2EE, Oracle DB, MQ, JavaScript, JSP/Servlets, and XML/SOAP services.",
      "Modernized and modularized legacy codebases applying Spring MVC, EJB refactoring, modular J2EE patterns, and front-end restructuring.",
      "Actively debugged, optimized, and resolved complex issues using Log4j, AppDynamics, Unix shell scripting, and JDBC tuning.",
      "Executed thorough system, integration, and regression testing using JUnit, Selenium, and manual test cycles."
    ]
  },
  {
    period: "April 2008 - April 2010",
    role: "Consultant Specialist",
    company: "HSBC",
    location: "Pune Area, India",
    details: [
      "Developed and enhanced key modules of the Account Opening System using IBM WebSphere Portal, J2EE, Oracle DB, MQ, JavaScript, JSP/Servlets, and XML/SOAP services.",
      "Refactored legacy components applying Spring MVC and improved J2EE design patterns for better performance and maintainability.",
      "Implemented and optimized integration workflows across MQ messaging, Oracle PL/SQL, and Portal components."
    ]
  },
  {
    period: "November 2004 - April 2008",
    role: "Software Engineer",
    company: "HSBC",
    location: "Pune Area, India",
    details: [
      "Built and delivered components on IBM Portal, J2EE, Oracle, MQ, and JavaScript stack as a hands-on developer.",
      "Contributed to feature delivery, defect resolution, and code quality for Internet Banking modules."
    ]
  },
  {
    period: "June 2004 - November 2004",
    role: "Software Engineer",
    company: "NetEdge Computing Solutions Pvt. Ltd.",
    location: "Noida Area, India",
    details: [
      "Early-career software engineering role focused on enterprise application development."
    ]
  }
];

export const TECHNICAL_FEEDS = [
  {
    id: "feed-ai-1",
    category: "ai_ml",
    title: "AI/ML Modernization in Corporate Banking",
    summary: "How AI/ML intelligence embedded across enterprise platforms is improving prediction, automation, and operational efficiency for institutional clients.",
    fullText: "Embedding AI/ML across corporate banking platforms unlocks transformational gains — from intelligent transaction screening and anomaly detection to predictive liquidity, churn modelling, and AIOps for platform resilience. The challenge isn't model accuracy alone; it's safe deployment within regulated environments, with strict explainability, model governance, and data residency controls. At FAB we apply layered MLOps pipelines and policy-bound inference gateways so that AI augments — never overrides — banker judgement.",
    author: "Rishab Salgotra",
    timestamp: "May 24, 2026",
    stats: "AI Embed: Cross-Platform | Governance: Policy-Bound",
    image: "https://lh3.googleusercontent.com/aida-public/AB6AXuBwdHt_RuD0bpSGLVrZ6Sr4numkaKOg4yHyas_R4FZZyGTXPHH-cJG0Lebr_5f_bgyuKdetrEKiLdKY2ukBCCJBgGYNFp4rQx9zJqxGnOdNeHDUWHY1NorDRf7oUDGV8xy6TwFj7ZzVqEuUprSjCQCDL0axHOo4nmNBuMhvwjNK-wjzeHFoNZiJqS-n-I_4LF-qrr_jU0SRdXfcADVEC3UGZnb0KtCE3R5mvXzICksQ5WsfLGrL8OPtsnHEBwU35TmmLTXUaMtBa5k"
  },
  {
    id: "feed-bc-1",
    category: "blockchain",
    title: "Tokenization & Smart Contracts for Corporate Settlement",
    summary: "Real-time settlement, digital assets, and smart contracts redefine how corporate clients move money and reconcile state across counterparties.",
    fullText: "Corporate settlement workflows traditionally span hours or days due to fragmented clearing, paper-trails, and reconciliation overhead. By codifying obligations into smart contracts and tokenizing balances on permissioned ledgers, banks deliver T+0 settlement, full auditability, and programmable money. Practical adoption requires careful design of permissioning, oracles, key custody, and integration with core ledger systems — but the operational upside for treasury, escrow, and trade finance is substantial.",
    author: "Rishab Salgotra",
    timestamp: "June 12, 2026",
    stats: "Settlement: T+0 | Use Cases: Tokenization, Escrow"
  },
  {
    id: "feed-q-1",
    category: "quantum",
    title: "Open Finance, APIs & Host-to-Host Connectivity",
    summary: "How API-led Connected Banking and embedded H2H pipelines are transforming corporate integration and open ecosystem connectivity.",
    fullText: "Modern corporate banking is moving from siloed channels to API-led ecosystems where treasury systems, ERPs, and marketplaces consume bank capabilities natively. Host-to-Host (H2H) remains essential for high-volume, secure file-based flows, while REST/Open APIs unlock real-time, event-driven integrations. A robust platform strategy treats both as first-class — sharing observability, security, and governance — so corporates can pick the connectivity model that fits each workflow.",
    author: "Rishab Salgotra",
    timestamp: "April 18, 2026",
    stats: "Channels: API + H2H | Pattern: Open Finance",
    image: "https://lh3.googleusercontent.com/aida-public/AB6AXuARUD9hHnwtqxhUFw9no6THxbP9G9ArXx6jC0EkqpIchBXUi5nL3Xyg1B1hsN_1hlSyogx30HJ6Br_CCRP3aIeT7JOFYVKi5AcRJqFrcqwjv-BCLVAlursnrjrGGHkVpU2F1P0fDSS5cBkWoV0pjwRNiLMX3bXTL7G8_nsy326zBlmA9zURkOaNmdHO7eaTimx0sPAex4HOnnKfxRtaJcitoNsa4e9IR7RAA4i7BUMp4QTvkmBe6nH83zc-2PdQA2GCd-sTR_az-Og"
  }
];

export const INITIAL_GUESTBOOK = [
  {
    id: "g-1",
    sender: "Alex Rivera",
    message: "Loved your perspective on API-led Connected Banking — looking forward to the next H2H deep-dive!",
    timestamp: Date.now() - 36 * 3600 * 1000,
    hash: "0x3Fde...9Bc3",
    ipPlaceholder: "192.168.1.101"
  },
  {
    id: "g-2",
    sender: "Circuit_Seeker",
    message: "Rishab, your work on browser foundation engineering at HSBC was a guide star for many of us. Great to see your FAB tokenization progress!",
    timestamp: Date.now() - 12 * 3600 * 1000,
    hash: "0xA7ec...14F2",
    ipPlaceholder: "89.207.132.4"
  },
  {
    id: "g-system-0",
    sender: "SYSTEM MONITOR",
    message: "Telemetry streams are fully synchronized. Guestbook transmission ports open and authenticated.",
    timestamp: Date.now(),
    hash: "0x00FF...FFFF",
    ipPlaceholder: "127.0.0.1",
    isSystemSignal: true
  }
];
